module.exports = __webpack_public_path__ + "static/media/sentMailSvg.18ebfc4e.svg";